import { useSelector } from '@xstate/react';
import usePolarisActor from 'src/hooks/usePolarisActor';
import type { IMachineState } from 'src/machines/polaris/types';

const identifiersSelector = (state: IMachineState) => {
  return state.context.identifiers || { age: { unit: 'year', value: '' }, sex: '', pov: 'self' };
};

const useIdentifiers = () => {
  const actor = usePolarisActor();
  return useSelector((actor as any).parent, identifiersSelector);
};

export default useIdentifiers;
